import { ReactNode } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import TickIcon from 'shared/icons/tick_green_icon.svg'
import TickRegularIcon from 'shared/icons/tick_regular.svg'

import styles from './styles.module.scss'

export enum TYPE_RESULT {
  RADIO = 'radio',
  CHECK_BOX = 'check_box',
}

interface OptionItem {
  key: string
  title: string
  prefix?: ReactNode
}

interface Props {
  title?: string
  rightText?: string
  active?: string[] | null
  typeOption?: TYPE_RESULT
  listOption: OptionItem[]
  onChange: (key: string | string[]) => void
  onClickRight?: (key: string | string[]) => void
}

export const BlockSelect = ({
  title,
  active,
  onChange,
  listOption,
  rightText,
  onClickRight,
  typeOption = TYPE_RESULT.CHECK_BOX,
}: Props) => {
  const { t } = useTranslation()

  if (!listOption?.length) return null

  const onClickHandler = (key: string) => {
    if (TYPE_RESULT.CHECK_BOX === typeOption) {
      if (active?.includes(key)) {
        onChange(active?.filter((item) => item !== key))
      } else {
        onChange([...(active || ''), key])
      }
    } else if (TYPE_RESULT.RADIO === typeOption) {
      onChange(key)
    }
  }

  const onSelectAll = () => {
    const listKeys = listOption?.map((option) => option.key)

    onChange(listKeys)
  }

  return (
    <div className={styles.container}>
      {title || onClickRight ? (
        <div className={styles.header}>
          {title && <p className={styles.title}>{title}</p>}

          {onClickRight ? (
            <button
              onClick={onSelectAll}
              className={styles.button}
            >
              {rightText || t('select_all')}
            </button>
          ) : null}
        </div>
      ) : null}

      <div className={styles.wrapperOptions}>
        {listOption?.map((item, index) => (
          <div
            key={'option' + item.key + index}
            onClick={() => onClickHandler(item.key)}
            className={clsx(styles.option)}
          >
            <div className={styles.left}>
              {item?.prefix && item.prefix}

              <span className={styles.name}> {item?.title} </span>
            </div>

            <div className={styles.indicator}>
              {typeOption === TYPE_RESULT.CHECK_BOX ? (
                active?.includes(item.key) ? (
                  <div className={styles.activeCheckBox}>
                    <img
                      src={TickIcon}
                      alt=""
                    />
                  </div>
                ) : (
                  <div className={styles.unActiveCheckBox} />
                )
              ) : null}

              {typeOption === TYPE_RESULT.RADIO ? (
                active?.includes(item.key) ? (
                  <div className={styles.activeRadio}>
                    <img
                      src={TickRegularIcon}
                      alt=""
                    />
                  </div>
                ) : (
                  <div className={styles.unActiveRadio} />
                )
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
